import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = {
  key: 0,
  class: "main_slide_wrap"
}
const _hoisted_3 = { class: "main_slide" }
const _hoisted_4 = ["href"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "btn_wrap _slide" }
const _hoisted_8 = {
  key: 1,
  class: "main_01"
}
const _hoisted_9 = { class: "wrap_1330" }
const _hoisted_10 = { class: "circle_wrap" }
const _hoisted_11 = { class: "circle" }
const _hoisted_12 = { class: "num_count_wrap" }
const _hoisted_13 = ["data-count"]
const _hoisted_14 = { class: "circle" }
const _hoisted_15 = { class: "num_count_wrap" }
const _hoisted_16 = ["data-count"]
const _hoisted_17 = { class: "circle" }
const _hoisted_18 = { class: "num_count_wrap" }
const _hoisted_19 = ["data-count"]
const _hoisted_20 = { class: "areaDateMain" }
const _hoisted_21 = {
  key: 2,
  class: "main_02"
}
const _hoisted_22 = { class: "wrap_1700" }
const _hoisted_23 = { class: "con_wrap" }
const _hoisted_24 = { class: "con" }
const _hoisted_25 = { class: "con" }
const _hoisted_26 = { class: "con" }
const _hoisted_27 = {
  key: 3,
  class: "main_03"
}
const _hoisted_28 = { class: "main_03_slide_wrap" }
const _hoisted_29 = { class: "main_03_slide" }
const _hoisted_30 = { class: "img_wrap" }
const _hoisted_31 = ["src"]
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = {
  key: 4,
  class: "main_04"
}
const _hoisted_35 = { class: "tit_wrap _white" }
const _hoisted_36 = { class: "con_wrap main_04_slide" }
const _hoisted_37 = ["src"]
const _hoisted_38 = ["src"]
const _hoisted_39 = {
  key: 5,
  class: "main_05"
}
const _hoisted_40 = { class: "wrap_1500" }
const _hoisted_41 = { class: "form_wrap" }
const _hoisted_42 = { class: "form_con" }
const _hoisted_43 = { class: "email_wrap input_default" }
const _hoisted_44 = {
  key: 0,
  class: "select_tab_box"
}
const _hoisted_45 = { class: "tab_option" }
const _hoisted_46 = ["onClick"]
const _hoisted_47 = {
  key: 1,
  class: "self_wrap",
  style: {"display":"block"}
}
const _hoisted_48 = {
  class: "agree_wrap",
  for: "privacy"
}
const _hoisted_49 = {
  key: 1,
  class: "pop_banner_wrap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!
  const _component_ModalPopup = _resolveComponent("ModalPopup")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.mainSectorList.list, (sector) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (sector.key === 'banner')
            ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  ($setup.bannerList.list.length > 0)
                    ? (_openBlock(), _createBlock(_component_swiper, {
                        key: 0,
                        ref_for: true,
                        ref: "swiperRef",
                        "space-between": 5,
                        loop: true,
                        onSwiper: $setup.onSwiper,
                        onSlideChange: $setup.onSlideChange,
                        style: {"height":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.bannerList.list, (item, idx) => {
                            return (_openBlock(), _createBlock(_component_swiper_slide, {
                              class: "img_wrap",
                              key: idx
                            }, {
                              default: _withCtx(() => [
                                (item.link)
                                  ? (_openBlock(), _createElementBlock("a", {
                                      key: 0,
                                      href: item.link
                                    }, [
                                      _createElementVNode("img", {
                                        src: $setup.isPc ? item.fileMobile : item.file,
                                        alt: "",
                                        onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.imgError && $setup.imgError(...args)))
                                      }, null, 40, _hoisted_5)
                                    ], 8, _hoisted_4))
                                  : (_openBlock(), _createElementBlock("img", {
                                      key: 1,
                                      src: $setup.isPc ? item.fileMobile : item.file,
                                      alt: "",
                                      onError: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.imgError && $setup.imgError(...args)))
                                    }, null, 40, _hoisted_6))
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["onSwiper", "onSlideChange"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("button", {
                      class: "prev_btn",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.prevSlide && $setup.prevSlide(...args)))
                    }, [...(_cache[15] || (_cache[15] = [
                      _createElementVNode("img", {
                        src: "img/next_btn.png",
                        alt: ""
                      }, null, -1)
                    ]))]),
                    _createElementVNode("button", {
                      class: "next_btn",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.nextSlide && $setup.nextSlide(...args)))
                    }, [...(_cache[16] || (_cache[16] = [
                      _createElementVNode("img", {
                        src: "img/next_btn.png",
                        alt: ""
                      }, null, -1)
                    ]))])
                  ])
                ])
              ]))
            : (sector.key === 'statics')
              ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
                  _cache[24] || (_cache[24] = _createStaticVNode("<div class=\"main_bg_wrap\" data-v-2519c9ca><i class=\"deco_01 _large blink_zoom3\" data-v-2519c9ca><img src=\"img/bg_deco_01.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_02 _medium blink_zoom1\" data-v-2519c9ca><img src=\"img/bg_deco_01.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_03 _xlarge blink_zoom3\" data-v-2519c9ca><img src=\"img/bg_deco_02.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_04 _medium spin_blink3\" data-v-2519c9ca><img src=\"img/bg_deco_01.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_05 _large blink_blink2\" data-v-2519c9ca><img src=\"img/bg_deco_02.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_06 _medium spin_blink2\" data-v-2519c9ca><img src=\"img/bg_deco_01.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_main_01\" data-v-2519c9ca><img src=\"img/main_01_deco_01.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_main_02\" data-v-2519c9ca><img src=\"img/main_01_deco_02.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_main_03\" data-v-2519c9ca><img src=\"img/main_01_deco_03.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_main_04\" data-v-2519c9ca><img src=\"img/main_01_deco_04.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_main_05\" data-v-2519c9ca><img src=\"img/main_01_deco_05.png\" alt=\"\" data-v-2519c9ca></i></div>", 1)),
                  _createElementVNode("div", _hoisted_9, [
                    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "tit_wrap" }, [
                      _createElementVNode("p", null, "시민과 함께한 불법산업 감시 행동"),
                      _createElementVNode("h2", null, "시민과 함께 만든 변화")
                    ], -1)),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _cache[17] || (_cache[17] = _createElementVNode("span", { class: "icon_wrap" }, [
                          _createElementVNode("img", {
                            src: "img/main_01_icon_01.png",
                            alt: ""
                          })
                        ], -1)),
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("div", {
                            class: "num_count",
                            "data-count": $setup.state.cnt_report
                          }, _toDisplayString($setup.state.cnt_report) + "건", 9, _hoisted_13)
                        ]),
                        _cache[18] || (_cache[18] = _createElementVNode("p", null, "전체 시민제보", -1))
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _cache[19] || (_cache[19] = _createElementVNode("span", { class: "icon_wrap" }, [
                          _createElementVNode("img", {
                            src: "img/main_01_icon_03.png",
                            alt: ""
                          })
                        ], -1)),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", {
                            class: "num_count",
                            "data-count": $setup.state.cnt_citizen_report
                          }, _toDisplayString($setup.state.cnt_citizen_report) + "건", 9, _hoisted_16)
                        ]),
                        _cache[20] || (_cache[20] = _createElementVNode("p", null, "신고/고발", -1))
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _cache[21] || (_cache[21] = _createElementVNode("span", { class: "icon_wrap" }, [
                          _createElementVNode("img", {
                            src: "img/main_01_icon_02.png",
                            alt: ""
                          })
                        ], -1)),
                        _createElementVNode("div", _hoisted_18, [
                          _createElementVNode("div", {
                            class: "num_count",
                            "data-count": $setup.state.cnt_citizen
                          }, _toDisplayString($setup.state.cnt_citizen) + "명", 9, _hoisted_19)
                        ]),
                        _cache[22] || (_cache[22] = _createElementVNode("p", null, "함께한 시민 수", -1))
                      ])
                    ]),
                    _createElementVNode("p", _hoisted_20, "*" + _toDisplayString($setup.CommonUtils.dateFormatYYYYMM(new Date($setup.state.date_main), ".")) + " 기준", 1)
                  ])
                ]))
              : (sector.key === 'ad')
                ? (_openBlock(), _createElementBlock("section", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _cache[31] || (_cache[31] = _createElementVNode("div", { class: "tit_wrap _white" }, [
                        _createElementVNode("h2", null, [
                          _createTextVNode(" 일상에서 성매매 업소, "),
                          _createElementVNode("br", { class: "only_640" }),
                          _createTextVNode(" 성매매 알선 광고를 "),
                          _createElementVNode("br"),
                          _createTextVNode(" 발견하셨다면 제보해주세요! ")
                        ]),
                        _createElementVNode("p", null, "*회원가입 없이 익명으로 제보 가능")
                      ], -1)),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _cache[26] || (_cache[26] = _createElementVNode("p", null, "성매매 의심업소", -1)),
                          _createVNode(_component_router_link, { to: "/areaWrite" }, {
                            default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                              _createElementVNode("span", null, "제보하기", -1),
                              _createElementVNode("img", {
                                src: "img/move_btn.png",
                                alt: ""
                              }, null, -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                          _cache[28] || (_cache[28] = _createElementVNode("p", null, "성매매 알선 광고", -1)),
                          _createVNode(_component_router_link, { to: "/adWrite" }, {
                            default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                              _createElementVNode("span", null, "제보하기", -1),
                              _createElementVNode("img", {
                                src: "img/move_btn.png",
                                alt: ""
                              }, null, -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _cache[30] || (_cache[30] = _createElementVNode("p", null, "시민제보 처리과정이 궁금하신가요?", -1)),
                          _createVNode(_component_router_link, { to: "/faqView/27" }, {
                            default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                              _createElementVNode("span", null, "알아보기", -1),
                              _createElementVNode("img", {
                                src: "img/move_btn.png",
                                alt: ""
                              }, null, -1)
                            ]))]),
                            _: 1
                          })
                        ])
                      ])
                    ])
                  ]))
                : (sector.key === 'board_entire')
                  ? (_openBlock(), _createElementBlock("section", _hoisted_27, [
                      _cache[33] || (_cache[33] = _createStaticVNode("<div class=\"main_bg_wrap\" data-v-2519c9ca><i class=\"deco_01 _medium blink_zoom2\" data-v-2519c9ca><img src=\"img/bg_deco_04.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_02 _medium blink_zoom4\" data-v-2519c9ca><img src=\"img/bg_deco_04.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_03 _xxlarge spin_blink2\" data-v-2519c9ca><img src=\"img/bg_deco_03.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_main_01\" data-v-2519c9ca><img src=\"img/main_03_deco_01.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_main_02\" data-v-2519c9ca><img src=\"img/main_03_deco_02.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_main_03\" data-v-2519c9ca><img src=\"img/main_03_deco_03.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_main_04 float2\" data-v-2519c9ca><img src=\"img/main_03_deco_04.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_main_05\" data-v-2519c9ca><img src=\"img/main_03_deco_05.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_main_06 float1\" data-v-2519c9ca><img src=\"img/main_03_deco_06.png\" alt=\"\" data-v-2519c9ca></i></div><div class=\"tit_wrap\" data-v-2519c9ca><span class=\"icon_wrap\" data-v-2519c9ca><img src=\"img/main_03_icon.png\" alt=\"\" data-v-2519c9ca></span><p data-v-2519c9ca>지금 참여할 수 있는 반성매매 활동</p><h2 data-v-2519c9ca>우리 함께 참여해요!</h2></div>", 2)),
                      _createElementVNode("div", _hoisted_28, [
                        _cache[32] || (_cache[32] = _createStaticVNode("<div class=\"btn_wrap _slide\" data-v-2519c9ca><button class=\"prev_btn\" data-v-2519c9ca><img src=\"img/next_btn.png\" alt=\"\" data-v-2519c9ca></button><button class=\"next_btn\" data-v-2519c9ca><img src=\"img/next_btn.png\" alt=\"\" data-v-2519c9ca></button></div>", 1)),
                        _createElementVNode("div", _hoisted_29, [
                          ($setup.boardList.list.length > 0)
                            ? (_openBlock(), _createBlock(_component_swiper, {
                                key: 0,
                                class: "swiper-wrapper",
                                modules: $setup.modules,
                                loop: true,
                                "centered-slides": true,
                                "slides-per-view": 1.7,
                                speed: 400,
                                navigation: {
                                    prevEl: '.main_03_slide_wrap .prev_btn',
                                    nextEl: '.main_03_slide_wrap .next_btn',
                                },
                                breakpoints: {
                                    641: { slidesPerView: 3, centeredSlides: true },
                                    1024: { slidesPerView: 5 },
                                }
                              }, {
                                default: _withCtx(() => [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.boardList.list, (item, idx) => {
                                    return (_openBlock(), _createBlock(_component_swiper_slide, {
                                      class: "swiper-slide",
                                      key: idx,
                                      onClick: ($event: any) => ($setup.moveBoard(item))
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("span", _hoisted_30, [
                                          (item.fileList && item.fileList.length > 0)
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                src: item.fileList[0].file,
                                                onError: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => ($setup.imgError && $setup.imgError(...args)))
                                              }, null, 40, _hoisted_31))
                                            : _createCommentVNode("", true)
                                        ]),
                                        (item.type === 1)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_32, "반성매매 시민활동"))
                                          : _createCommentVNode("", true),
                                        (item.type === 2)
                                          ? (_openBlock(), _createElementBlock("span", _hoisted_33, "캠페인·이벤트"))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modules"]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  : (sector.key === 'board_news')
                    ? (_openBlock(), _createElementBlock("section", _hoisted_34, [
                        _cache[36] || (_cache[36] = _createStaticVNode("<div class=\"main_bg_wrap\" data-v-2519c9ca><i class=\"deco_03\" data-v-2519c9ca><img src=\"img/main_04_deco_02.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_04\" data-v-2519c9ca><img src=\"img/main_04_deco_03.png\" alt=\"\" data-v-2519c9ca></i></div>", 1)),
                        _createElementVNode("div", _hoisted_35, [
                          _cache[35] || (_cache[35] = _createStaticVNode("<div class=\"main_bg_wrap\" data-v-2519c9ca><i class=\"deco_01\" data-v-2519c9ca><img src=\"img/main_04_deco_01.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_02\" data-v-2519c9ca><img src=\"img/main_04_deco_04.png\" alt=\"\" data-v-2519c9ca></i></div><span class=\"icon_wrap\" data-v-2519c9ca><img src=\"img/main_04_icon.png\" alt=\"\" data-v-2519c9ca></span><p data-v-2519c9ca> 다시함께상담센터의 불법성산업 <br class=\"none_1240\" data-v-2519c9ca> 감시 소식을 확인하세요 </p><h2 data-v-2519c9ca>감시소식</h2>", 4)),
                          _createVNode(_component_router_link, {
                            to: "/news",
                            class: "more_btn",
                            style: {"z-index":"1"}
                          }, {
                            default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                              _createTextVNode(" 더보기 ", -1),
                              _createElementVNode("img", {
                                src: "img/more_btn.png",
                                alt: ""
                              }, null, -1)
                            ]))]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                          _createVNode(_component_swiper, {
                            class: "swiper-wrapper",
                            modules: $setup.modules,
                            loop: false,
                            "slide-to-clicked-slide": false,
                            "centered-slides": true,
                            "slides-per-view": 1.02,
                            breakpoints: {
                                640: { slidesPerView: 2.2, spaceBetween: 20, centeredSlides: false },
                                768: { slidesPerView: 3.2, spaceBetween: 20, centeredSlides: false },
                                1024: { slidesPerView: 4, spaceBetween: 30, centeredSlides: false },
                            }
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.gamsiList.list, (item, idx) => {
                                return (_openBlock(), _createBlock(_component_swiper_slide, {
                                  class: "img_wrap swiper-slide",
                                  key: idx
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_router_link, {
                                      to: { name: 'NewsView', params: { id: item.idx } }
                                    }, {
                                      default: _withCtx(() => [
                                        (item.fileList && item.fileList.length > 0)
                                          ? (_openBlock(), _createElementBlock("img", {
                                              key: 0,
                                              src: item.fileList[0].file,
                                              onError: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => ($setup.imgError && $setup.imgError(...args)))
                                            }, null, 40, _hoisted_37))
                                          : (_openBlock(), _createElementBlock("img", {
                                              key: 1,
                                              src: item.fileList,
                                              onError: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => ($setup.imgError && $setup.imgError(...args)))
                                            }, null, 40, _hoisted_38))
                                      ]),
                                      _: 2
                                    }, 1032, ["to"])
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modules"])
                        ])
                      ]))
                    : (sector.key === 'subscribe')
                      ? (_openBlock(), _createElementBlock("section", _hoisted_39, [
                          _cache[42] || (_cache[42] = _createStaticVNode("<div class=\"main_bg_wrap\" data-v-2519c9ca><i class=\"deco_01 _large _white spin_blink3\" data-v-2519c9ca><img src=\"img/bg_deco_03.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_02 _small blink_blink3\" data-v-2519c9ca><img src=\"img/bg_deco_04.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_03 _xsmall _white blink_blink2\" data-v-2519c9ca><img src=\"img/bg_deco_01.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_04 _xsmall _white\" data-v-2519c9ca><img src=\"img/bg_deco_02.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_05 _small _white spin_blink3\" data-v-2519c9ca><img src=\"img/bg_deco_01.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_06 _small _white blink_zoom3\" data-v-2519c9ca><img src=\"img/bg_deco_01.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_07 _small _white\" data-v-2519c9ca><img src=\"img/bg_deco_02.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_08 _small\" data-v-2519c9ca><img src=\"img/bg_deco_02.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_09 _medium spin_blink2\" data-v-2519c9ca><img src=\"img/bg_deco_03.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_10 _medium\" data-v-2519c9ca><img src=\"img/bg_deco_06.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_11 _xlarge\" data-v-2519c9ca><img src=\"img/bg_deco_07.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_12 _small _white spin_blink2\" data-v-2519c9ca><img src=\"img/bg_deco_02.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_13 _medium _white\" data-v-2519c9ca><img src=\"img/bg_deco_03.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_14 _xxsmall _white blink4\" data-v-2519c9ca><img src=\"img/bg_deco_05.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_15 _medium _white spin_blink3\" data-v-2519c9ca><img src=\"img/bg_deco_01.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_16 _small blink_zoom4\" data-v-2519c9ca><img src=\"img/bg_deco_03.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_17 _small _white\" data-v-2519c9ca><img src=\"img/bg_deco_02.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_18 _xsmall _white blink_blink4\" data-v-2519c9ca><img src=\"img/bg_deco_05.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_19 _xxsmall blink3\" data-v-2519c9ca><img src=\"img/bg_deco_05.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_main_01\" data-v-2519c9ca><img src=\"img/main_05_deco_01.png\" alt=\"\" data-v-2519c9ca></i><i class=\"deco_main_02\" data-v-2519c9ca><img src=\"img/main_05_deco_02.png\" alt=\"\" data-v-2519c9ca></i></div>", 1)),
                          _createElementVNode("div", _hoisted_40, [
                            _cache[41] || (_cache[41] = _createStaticVNode("<div class=\"tit_wrap _white\" data-v-2519c9ca><p data-v-2519c9ca>다시함께의 다양한 성매매 방지 활동 소식이 궁금하시다면?</p><h2 class=\"areaNewsTitle\" data-v-2519c9ca><span style=\"margin-bottom:20px;\" data-v-2519c9ca> 다시함께상담센터 <br data-v-2519c9ca> 뉴스레터 구독하기 </span><a href=\"https://dasihamkke.stibee.com/\" class=\"submit_btn areaNewsLink\" style=\"\" data-v-2519c9ca> 센터의 이전 활동들을 확인해보세요! <img src=\"img/move_btn.png\" alt=\"\" data-v-2519c9ca></a></h2></div>", 1)),
                            _createElementVNode("div", _hoisted_41, [
                              _createElementVNode("div", _hoisted_42, [
                                _withDirectives(_createElementVNode("input", {
                                  class: "input_default name_wrap",
                                  type: "text",
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.subscribe_state.name) = $event)),
                                  placeholder: "이름"
                                }, null, 512), [
                                  [_vModelText, $setup.subscribe_state.name]
                                ]),
                                _createElementVNode("div", _hoisted_43, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "text",
                                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.subscribe_state.emailId) = $event)),
                                    placeholder: "이메일"
                                  }, null, 512), [
                                    [_vModelText, $setup.subscribe_state.emailId]
                                  ]),
                                  _cache[38] || (_cache[38] = _createElementVNode("span", null, "@", -1)),
                                  (!$setup.state.isDirect && $setup.state.select_domain !== '직접입력')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                                        _createElementVNode("div", {
                                          class: _normalizeClass(["selected_tab", [$setup.state.isActive ? 'active' : '']]),
                                          onClick: _cache[9] || (_cache[9] = ($event: any) => ($setup.state.isActive = !$setup.state.isActive))
                                        }, [
                                          _createElementVNode("span", null, _toDisplayString($setup.state.select_domain), 1)
                                        ], 2),
                                        _createElementVNode("div", _hoisted_45, [
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.email_domain_list, (value, idx) => {
                                            return (_openBlock(), _createElementBlock("button", {
                                              key: idx,
                                              onClick: ($event: any) => {
                                                    $setup.subscribe_state.emailDomain = value;
                                                    $setup.state.email_domain = value;
                                                    $setup.state.isActive = false;
                                                    $setup.state.select_domain = value;
                                                    $setup.state.isDirect = false;
                                                },
                                              class: _normalizeClass([$setup.state.email_domain === value ? 'active' : ''])
                                            }, _toDisplayString(value), 11, _hoisted_46))
                                          }), 128)),
                                          _createElementVNode("button", {
                                            class: "self",
                                            onClick: _cache[10] || (_cache[10] = ($event: any) => {
                                                    $setup.state.email_domain = '';
                                                    $setup.state.isActive = false;
                                                    $setup.state.select_domain = '직접입력';
                                                    $setup.state.isDirect = true;
                                                    $setup.subscribe_state.emailDomain = '';
                                                })
                                          }, " 직접입력 ")
                                        ])
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_47, [
                                        _withDirectives(_createElementVNode("input", {
                                          type: "text",
                                          class: "",
                                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.subscribe_state.emailDomain) = $event)),
                                          placeholder: "직접입력"
                                        }, null, 512), [
                                          [_vModelText, $setup.subscribe_state.emailDomain]
                                        ]),
                                        _createElementVNode("button", {
                                          onClick: _cache[12] || (_cache[12] = ($event: any) => {
                                                $setup.state.isDirect = false;
                                                $setup.state.select_domain = $setup.state.email_domain = $setup.subscribe_state.emailDomain = $setup.email_domain_list[0];
                                            })
                                        }, [...(_cache[37] || (_cache[37] = [
                                          _createElementVNode("img", {
                                            src: "img/erase.png",
                                            alt: ""
                                          }, null, -1)
                                        ]))])
                                      ]))
                                ]),
                                _createElementVNode("label", _hoisted_48, [
                                  _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    id: "privacy",
                                    "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($setup.subscribe_state.isAgree) = $event))
                                  }, null, 512), [
                                    [_vModelCheckbox, $setup.subscribe_state.isAgree]
                                  ]),
                                  _cache[39] || (_cache[39] = _createElementVNode("em", null, null, -1)),
                                  _cache[40] || (_cache[40] = _createElementVNode("p", null, "개인정보 수집 및 이용에 동의합니다.", -1))
                                ])
                              ]),
                              _createElementVNode("button", {
                                class: "submit_btn",
                                onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => ($setup.subscribe && $setup.subscribe(...args))),
                                style: {"margin-bottom":"39px"}
                              }, "구독하기")
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
        ], 64))
      }), 256))
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true),
    ($setup.popupBannerList && $setup.popupBannerList.list.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.popupBannerList.list, (item) => {
            return (_openBlock(), _createBlock(_component_ModalPopup, {
              key: item.idx,
              item: item
            }, null, 8, ["item"]))
          }), 128))
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_Footer)
  ], 64))
}